// Quick Add to Cart functionality for product cards
function initProductCard(productId) {
  const productCard = document.querySelector(`[data-product-id="${productId}"]`);
  if (!productCard) return;
  
  // Check if already initialized
  if (productCard.dataset.initialized === 'true') return;
  productCard.dataset.initialized = 'true';
  
  const quickAddBtn = productCard.querySelector('.quick-add-btn');
  const sizeSelector = productCard.querySelector('.quick-size-selector');
  const sizeClose = productCard.querySelector('.quick-size-close');
  const sizeOptions = productCard.querySelectorAll('.quick-size-option');
  const form = productCard.querySelector('form');
  const variantInput = productCard.querySelector('.variant-id-input');
  const variantsCount = parseInt(quickAddBtn?.dataset.variantsCount || '1');
  
  if (!quickAddBtn) return;
  
  // Store original button HTML
  const originalButtonHTML = quickAddBtn.innerHTML;
  
  // Add to cart via AJAX
  function addToCart(variantId) {
    quickAddBtn.disabled = true;
    quickAddBtn.innerHTML = 'Adding...';
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Trigger cart drawer open and update count
      window.dispatchEvent(new CustomEvent('cart-updated'));
      window.dispatchEvent(new CustomEvent('open-cart-drawer'));
      
      // Reset button
      quickAddBtn.disabled = false;
      quickAddBtn.innerHTML = originalButtonHTML;
    })
    .catch(error => {
      quickAddBtn.disabled = false;
      quickAddBtn.innerHTML = originalButtonHTML;
      alert('Error adding to cart. Please try again.');
    });
  }
  
  // Handle add to cart click
  quickAddBtn.addEventListener('click', function(e) {
    e.preventDefault();
    
    if (variantsCount > 1) {
      // Show size selector
      if (sizeSelector) {
        sizeSelector.style.display = 'block';
      }
    } else {
      // Single variant - add directly
      addToCart(variantInput.value);
    }
  });
  
  // Handle size selection
  if (sizeOptions) {
    sizeOptions.forEach(option => {
      option.addEventListener('click', function() {
        if (this.classList.contains('disabled')) return;
        
        const variantId = this.dataset.variantId;
        variantInput.value = variantId;
        
        // Hide selector and add to cart
        if (sizeSelector) sizeSelector.style.display = 'none';
        addToCart(variantId);
      });
    });
  }
  
  // Handle close button
  if (sizeClose) {
    sizeClose.addEventListener('click', function() {
      if (sizeSelector) sizeSelector.style.display = 'none';
    });
  }
  
  // Close on outside click
  const outsideClickHandler = function(e) {
    if (sizeSelector && !productCard.contains(e.target)) {
      sizeSelector.style.display = 'none';
    }
  };
  document.addEventListener('click', outsideClickHandler);
}

// Initialize all product cards on page load
document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('[data-product-id]');
  productCards.forEach(card => {
    const productId = card.dataset.productId;
    if (productId) {
      initProductCard(productId);
    }
  });
});

// Re-initialize for dynamically loaded products (ajaxinate)
if (typeof window.initProductCard === 'undefined') {
  window.initProductCard = initProductCard;
}
